export default __webpack_public_path__ + "static/media/updated-version.74d61f14.png";